<template>
  <div class="daoh2">
      <div class="ti">
         <transition>
          <keep-alive>
              <router-view></router-view>
          </keep-alive>
         </transition>
      </div>
  </div>
</template>

<script>
  export default {
    name: "customer",
    data(){
      return{

      }
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/index.vue